import React, { useEffect, useState } from "react";
import useAxiosPrivate from "../../hooks/useAxiosPrivate.js"; // Import your configured axios instance
import "./UsersList.css"; // Import the CSS file
import { formatDate } from "../../utils/Utilities.js";
import { useNavigate } from "react-router-dom";
import TopBar from "./TopBar";
import { Col, Container, Form, Row } from "react-bootstrap";
import useAuth from "../../hooks/useAuth";

const GetBookConsignmentByDate = () => {
  const handleRedirect = () => {
    // navigate("/consignmentbooking");
    navigate("/booking");
  }
  const [BookingsByDateConsignment, setBookingsByDateConsignment] = useState([]); // To store list of BookingsByDateConsignment
  const [loading, setLoading] = useState(false); // Set loading initially to false
  const [error, setError] = useState(null); // To handle errors
  const [currentPage, setCurrentPage] = useState(1); // Current page for pagination
  const [fromDate, setFromDate] = useState(""); // To store the from_date value
  const [toDate, setToDate] = useState(""); // To store the to_date value
  const BookingsByDateConsignmentPerPage = 10; // Number of BookingsByDateConsignment per page
  const axiosPrivate = useAxiosPrivate();
  const { auth } = useAuth();
  const GET_BOOKINGS_BY_DATE_CONSIGNMENT_URL = "api/get-bookings-by-date"; // Replace with the correct API endpoint to fetch BookingsByDateConsignment

  const navigate = useNavigate();
  const handleViewClick = (booking_id) => {
    window.open(`/GetBooking/${booking_id}`, '_blank');
  };

  const handleEditClick = (booking_id) => {
    window.open(`/UpdateConsignment/${booking_id}`, '_blank');
  };


  // Fetch BookingsByDateConsignment based on from_date and to_date
  const fetchBookingsByDateConsignment = async (fromDate, toDate) => {
    setLoading(true); // Start loading spinner
    try {
      const fromDate_Formated = formatDate(fromDate);
      const toDate_Formated = formatDate(toDate);
      const data = {
        franchise_id: auth.franchise_id,
        from_date: fromDate_Formated,
        to_date: toDate_Formated,
      };

      const response = await axiosPrivate.get(GET_BOOKINGS_BY_DATE_CONSIGNMENT_URL, {
        params: data,
      });

      setBookingsByDateConsignment(response.data); // Store the list of BookingsByDateConsignment into the state
      setLoading(false); // Stop loading spinner
      setError(null); // Clear any previous error
    } catch (error) {
      console.error("Error fetching Bookings Consignments:", error);
      setError("Failed to load Booking Consignments");
      setLoading(false); // Set loading to false even if there is an error
    }
  };

  // Handle the search button click to fetch data with the new dates
  const handleSearch = () => {
    if (fromDate && toDate) {
      fetchBookingsByDateConsignment(fromDate, toDate);
      setError(null); // Clear the error if dates are valid
    } else {
      setError("Please enter both from and to dates."); // Show error if dates are missing
    }
  };

  // Paginate BookingsByDateConsignment
  const indexOfLastBookingsByDateConsignment = currentPage * BookingsByDateConsignmentPerPage;
  const indexOfFirstBookingsByDateConsignment = indexOfLastBookingsByDateConsignment - BookingsByDateConsignmentPerPage;
  const currentBookingsByDateConsignment = BookingsByDateConsignment.slice(indexOfFirstBookingsByDateConsignment, indexOfLastBookingsByDateConsignment);

  // Pagination handler
  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  // Total pages needed for pagination
  const totalPages = Math.ceil(BookingsByDateConsignment.length / BookingsByDateConsignmentPerPage);

  if (loading) {
    return <div className="loading">Loading...</div>;
  }

  return (
    <>


      <section className="newsections">


        <div className="newwrap">
          <div className="d-flex align-items-center">
            <button onClick={() => navigate(-1)} className="btn btn-secondary newviewbtn"> ← Back</button>
            <button onClick={handleRedirect} type="button" className="btn btn-success ms-auto d-block top-bt">+ Book Consignment</button>
          </div>
          <h3>Consignment List</h3>

          {/* Date Filters and Search Button */}
          <center>
            <div className="search-filters newfilter">
              <label htmlFor="fromDate">From Date:</label>
              <input
                type="date"
                id="fromDate"
                value={fromDate}
                onChange={(e) => setFromDate(e.target.value)}
              />
              <label htmlFor="toDate">To Date:</label>
              <input
                type="date"
                id="toDate"
                value={toDate}
                onChange={(e) => setToDate(e.target.value)}
              />
              <br />
              <button onClick={handleSearch} className="btn scanbutton">Search</button>
            </div>
          </center>

          {/* Show error message if both dates are not provided */}
          {error && (
            <div className="error-message">
              <div className="error">{error}</div>
              {/* Show the search filters again below the error */}
            </div>
          )}

          {/* Show the table for displaying BookingsByDateConsignment only when there are results */}
          {BookingsByDateConsignment.length > 0 && !error && (
            <>
              <table border="1" id="customers">
                <thead>
                  <tr>
                    <th>Booking ID</th>
                    <th>Booking Date</th>
                    <th>Payment Mode</th>
                    <th>Service Type</th>
                    <th>Consigner Name</th>
                    <th>Consigner Mobile</th>
                    <th>Options</th>
                  </tr>
                </thead>
                <tbody>
                  {currentBookingsByDateConsignment.map((BookingsByDateConsignment) => (
                    <tr key={BookingsByDateConsignment.booking_id}>
                      <td>{BookingsByDateConsignment.booking_id}</td>
                      <td>{BookingsByDateConsignment.booking_date}</td>
                      <td>{BookingsByDateConsignment.payment_mode}</td>
                      <td>{BookingsByDateConsignment.service_type}</td>
                      <td>{BookingsByDateConsignment.consigner_name}</td>
                      <td>{BookingsByDateConsignment.consigner_mobile}</td>
                      <td>
                        <button
                          type="button"
                          className="btn btn-primary btn-ico"
                          onClick={() => handleViewClick(BookingsByDateConsignment.booking_id)}>
                          <i className="bx bxs-show icon"></i>
                        </button>

                        <button
                          type="button"
                          className="btn btn-warning btn-ico"
                          onClick={() => handleEditClick(BookingsByDateConsignment.booking_id)}>
                          <i className="bx bxs-edit icon"></i>
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>

              {/* Pagination - only show if there are multiple pages */}
              {totalPages > 1 && (
                <div className="pagination">
                  {Array.from({ length: totalPages }, (_, index) => (
                    <button
                      key={index}
                      onClick={() => handlePageChange(index + 1)}
                      disabled={currentPage === index + 1}>
                      {index + 1}
                    </button>
                  ))}
                </div>
              )}
            </>
          )}

          {/* If no BookingsByDateConsignment and error isn't shown, display a "No results" message */}
          {BookingsByDateConsignment.length === 0 && !loading && !error && (
            <div className="no-results">
              <p>No Booking Consignments found for the selected date range.</p>
            </div>
          )}
        </div>
      </section>
      <TopBar />
    </>
  );
};

export default GetBookConsignmentByDate;
